export default __webpack_public_path__ + "a0ce8d3ba73fd6340d6ed2793e941682.svg";